import React from "react";
import { Aside } from "sprint-common-web";

import { CloudFileStatusDetailsAsideContent } from "./CloudFileStatusDetailsAsideContent";

export interface CloudFileStatusDetailsAsideProps {
    cloudFileId: string;
    isOpen: boolean;
    onClose?(): void;
}

export const CloudFileStatusDetailsAside: React.FC<CloudFileStatusDetailsAsideProps> = (
    props: CloudFileStatusDetailsAsideProps
) => {
    const { cloudFileId, isOpen, onClose } = props;

    const handleDismiss = () => {
        if (onClose) {
            onClose();
        }
    };

    return (
        <Aside
            isOpen={isOpen}
            headerText="Status details"
            type="readonly"
            onDismiss={handleDismiss}
            isLightDismiss={true}
        >
            <CloudFileStatusDetailsAsideContent cloudFileId={cloudFileId} />
        </Aside>
    );
};
